var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullscreenToggleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:fullscreen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 20.9922V15.9922H5V18.9922H8V20.9922H3ZM16 20.9922V18.9922H19V15.9922H21V20.9922H16ZM3 7.99219V2.99219H8V4.99219H5V7.99219H3ZM19 7.99219V4.99219H16V2.99219H21V7.99219H19Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenToggleIcon);
export default __webpack_public_path__ + "static/media/fullscreen-toggle-icon.f980e8c148f21dc1ad45a46c865eaa5d.svg";
export { ForwardRef as ReactComponent };